export default __webpack_public_path__ + "static/media/atlanta.a3a80d33.png";